
export class EventName {

  public static Outbound = {
    authentication: 'AUTHENTICATION',
    assetTwRequestData: 'ASSET_TW_REQUEST_DATA',
    lineTwRequestData: 'LINE_TW_REQUEST_DATA',
    lineSegmentTwRequestData: 'LINE_TW_REQUEST_DATA',
    plantTwRequestData: 'PLANT_TW_REQUEST_DATA',
    lineHeaderRequestData: 'LINE_HEADER_REQUEST_DATA',
    lineAlertCountRequestData: 'LINE_ALERT_COUNT_REQUEST_DATA',
    lineStatusRequestData: 'LINE_STATUS_REQUEST_DATA',
    dataSubscription: 'DATA_SUBSCRIPTION',
    alertPopupNotificationRequest: 'ALERT_POPUP_NOTIFICATION_REQUEST',
    shiftStatusRequest: 'SHIFT_STATUS_REQUEST',
  };

  public static Inbound = {
    connect: 'connect',
    disconnect: 'disconnect',
    authenticated: 'AUTHENTICATED',
    unauthenticated: 'UNAUTHENTICATED',
    unauthorized: 'UNAUTHORIZED',
    data: 'DATA',
    alertPopupNotificationResponse: 'ALERT_POPUP_NOTIFICATION_RESPONSE',
  };
}
